import React, { Component } from 'react';


class Step1 extends Component {

    render() {
        return (
            <div className="card card-body">
                <div className="form-group">
                    <label htmlFor="date">Date of Inspection</label>
                    <div className="input-group">
                        <input id="date" name="date" type="date" required="required" className="form-control here" />
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="buildingName">Building Name</label>
                    <input id="buildingName" name="buildingName" type="text" required="required" className="form-control here" />
                </div >
                <div className="form-group">
                    <label htmlFor="buildingAddress">Building Address</label>
                    <input id="buildingAddress" name="buildingAddress" type="text" required="required" className="form-control here" />
                </div >
                <div className="form-group">
                    <label htmlFor="systemNumber">System Number</label>
                    <input id="systemNumber" name="systemNumber" type="text" required="required" className="form-control here" />
                </div >
            </div >
        );
    }
};

export default Step1;



// WEBPACK FOOTER //
// ./src/components/Step1.js